module.exports = __webpack_public_path__ + "media/images/front/varieties/ORTANIQUE-732e392c2362ffc65142831d82de2351.jpg";